module.exports = __webpack_public_path__ + "img/ranking3.98e84844.png";